import { render, staticRenderFns } from "./QRReceipt.vue?vue&type=template&id=5873866a&"
import script from "./QRReceipt.vue?vue&type=script&lang=js&"
export * from "./QRReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports